<template>
  <div>
    <div v-if="loading">
      <img src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/default-images/Loading_screen_1750px.svg" alt="" srcset="">
      <img src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/default-images/Loading_screen_1750px.svg" alt="" srcset="">
      <img src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/default-images/Loading_screen_1750px.svg" alt="" srcset="">
    </div>

    <div v-if="!loading">
      <div v-if="brandsData && brandsData.brandComplex && brandsData.brandComplex.BrandComplex 
        && brandsData.brandComplex.BrandComplex.experiences && brandsData.brandComplex.BrandComplex.experiences.length">
          <div v-for="(editors, index) in brandsData.brandComplex.BrandComplex.experiences" :key="index" class="my-5">
            <brandPocEditors v-bind:editors="editors" v-bind:brandData="brandsData.brandComplex.BrandComplex" v-bind:settingsPerm="settingsPerm"></brandPocEditors>
          </div>
      </div>

      <!-- top widget only displayed on small devices -->
      <div class="d-block d-lg-none mb-4">
        <span v-html="rightSideWidgetTop"></span>
      </div>

      <!-- brands related feature Issue and Live -->
      <brandPocFeature class="mb-5" v-bind:settingsPerm="settingsPerm" queryType="ISSUE"></brandPocFeature>
      <brandPocFeature class="mb-5" v-bind:settingsPerm="settingsPerm" queryType="LIVE"></brandPocFeature>

      <!-- recordings display -->
      <brandPocFeature class="mb-5" v-bind:settingsPerm="settingsPerm" queryType="LIVE_PAST"></brandPocFeature>

      <!-- Magazin issue display -->
      <magazinesFeature v-bind:settingsPerm="settingsPerm" v-bind:brandData="brandsData.brandComplex.BrandComplex"></magazinesFeature>

      <!-- in stream widget display 1 -->
      <span v-if="widgetMainOne">
        <span v-html="widgetMainOne"></span>
      </span>

      <!-- brands related feature Academy and Read -->
      <brandPocFeature class="mb-5" v-bind:settingsPerm="settingsPerm" queryType="ACADEMY"></brandPocFeature>
      <brandPocFeature class="mb-5" v-bind:settingsPerm="settingsPerm" queryType="READ"></brandPocFeature>

      <!-- Experts slider display -->
      <expertsFeature v-bind:settingsPerm="settingsPerm" v-bind:experts="experts" v-bind:brandData="brandsData.brandComplex.BrandComplex._id"></expertsFeature>

      <!-- in stream widget display 2 -->
      <span v-if="widgetMainTwo">
          <span v-html="widgetMainTwo"></span>
      </span>


      <!-- brands related feature RHEINGOLD and CAMP -->
      <brandPocFeature class="mb-5" v-bind:settingsPerm="settingsPerm" queryType="RHEINGOLD"></brandPocFeature>
      <brandPocFeature class="mb-5" v-bind:settingsPerm="settingsPerm" queryType="CAMP"></brandPocFeature>

      <!-- Magazin issue display -->
      <magazinesFeature v-bind:settingsPerm="settingsPerm" v-bind:displayLatestBrands="true"></magazinesFeature>
      
      <!-- brand instances display -->
      <brandInstances v-bind:settingsPerm="settingsPerm" v-bind:brandData="brandsData"></brandInstances>

      <!-- Partners slider display -->
      <partnersFeature v-bind:settingsPerm="settingsPerm" v-bind:partners="partners" v-bind:brandData="brandsData.brandComplex.BrandComplex._id"></partnersFeature>

      <!-- bottom widget only displayed on small devices -->
      <div class="d-block d-lg-none">
        <span v-html="rightSideWidgetBottom"></span>
      </div>

    </div>
  </div>
</template>

<script>
import brandPocFeature from "./brandPocFeature.vue";
import brandPocEditors from "./BrandPocEditors.vue";
import brandInstances from "./BrandInstances.vue";
import partnersFeature from "./partnersFeature.vue";
import expertsFeature from "./expertsFeature.vue";
import magazinesFeature from "./magazinesFeature.vue";

export default {
  name: "brandRelatedFeatures",
  props: {
    settingsPerm: Object,
    brandComplex: Object,
    widgetMainOne: Object,
    widgetMainTwo: Object,
    rightSideWidgetTop: Object,
    rightSideWidgetBottom: Object,
    brandInputData: Object,
    displayLatestBrands: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      brandSlug: false,
      brandsData: null,
    };
  },
  setup() {},
  components: {
    brandPocEditors,
    brandPocFeature,
    brandInstances,
    partnersFeature,
    expertsFeature,
    magazinesFeature
  },

  created() {
    if (this.brandInputData && this.brandInputData.brandComplex && this.brandInputData.brandComplex.BrandComplex) {
      this.brandsData = this.brandInputData;
    }
  },

  methods: {
  },

};
</script>

<style scoped>
</style>
